import { EmptyState as PolarisEmptyState, Card } from "@shopify/polaris";

interface Props {
  heading: string;
  action?: { content: string; onAction: () => void };
  children?: React.ReactNode;
  image?: string;
}

const DEFAULT_IMAGE =
  "https://cdn.shopify.com/s/files/1/0757/9955/files/empty-state.svg";

export default function EmptyState({ heading, action, children, image }: Props): JSX.Element {
  return (
    <Card>
      <PolarisEmptyState heading={heading} action={action} image={image ?? DEFAULT_IMAGE}>
        {children}
      </PolarisEmptyState>
    </Card>
  );
}
